<template>
  <div></div>
</template>

<script>
export default {
  name: "PasswordReset",

  mounted() {
    this.$store.commit("setAuthDialog", {
      visible: true,
      type: "resetPassword",
      callback: (newPassword) => {
        this.$http
          .patch(
            this.$store.state.api +
              "/user/reset/password/" +
              this.$route.params.token,
            { newPassword: newPassword },
            {}
          )
          .then((response) => {
            this.$store.commit("setSnackbar", {
              text:
                "Successfully changed password for user " + response.data.email,
            });
            this.$router.push({ name: "Login" }).catch(() => {
              // to avoid NavigationDuplicated Navigating to current location /login is not allowed
            });
          })
          .catch(() => {
            this.$store.commit("setSnackbar", {
              text: "Failed to change password",
              color: "var(--attention)",
            });
          });
      },
    });
  },
};
</script>